import React, { useState, useEffect } from "react";
import axios from "axios";
import socket from "../tools/socke";
import * as XLSX from "xlsx"; // Importa la librería XLSX
import InfoCadete from "../tools/InfoCadete";

const DevuelveAvisos = ({ sede }) => {
  const [cadetes, setCadetes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para traer datos de la API
  const traeme = async () => {
    try {
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/devuelveAvisosPorSede",
        { sede }
      );
      if (Array.isArray(response.data)) {
        setCadetes(response.data);
      } else {
        throw new Error("Los datos recibidos no son un array.");
      }
    } catch (err) {
      setError(err.message || "Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    traeme();
    socket.on("avisoActualizado", () => {
      traeme();
    });

    return () => {
      socket.off("avisoActualizado");
    };
  }, []);

  // Función para formatear fecha y hora
  const formatFechaHora = (fecha) => {
    if (!fecha) return "Sin fecha";
    const date = new Date(fecha);
    return date.toLocaleString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  // Agrupar cadetes por Seccion.Compania.nombre
  const groupedByCompania = cadetes.reduce((acc, cadeteData) => {
    const cadete = cadeteData.cadete;
    const companiaNombre = cadete?.Seccion?.Compania?.nombre;
    const fechaAviso = cadeteData.fecha;
    const Motivo = cadeteData.tipo;
    const descripcion = cadeteData.descripcion;
    const cadeteSede = cadeteData.cadete.cadeteSede;

    if (!companiaNombre) {
      return acc;
    }

    if (!acc[companiaNombre]) {
      acc[companiaNombre] = [];
    }

    acc[companiaNombre].push({
      ...cadete,
      fechaAviso,
      Motivo,
      descripcion,
      cadeteSede,
    });
    return acc;
  }, {});

  // Ordenar los cadetes dentro de cada compañía por fechaAviso (más reciente primero) y luego por apellido
  Object.keys(groupedByCompania).forEach((compania) => {
    groupedByCompania[compania].sort((a, b) => {
      const fechaA = new Date(a.fechaAviso).getTime();
      const fechaB = new Date(b.fechaAviso).getTime();
      if (fechaA !== fechaB) {
        return fechaB - fechaA; // Ordenar de más reciente a más antiguo
      }
      return a.cadeteApellido.localeCompare(b.cadeteApellido); // Si las fechas son iguales, ordenar por apellido
    });
  });

  // Función para generar y descargar el archivo Excel
  const exportToExcel = () => {
    const rows = [];

    // Añadir encabezados
    rows.push(["Compañía", "Fecha Aviso", "Apellido", "Nombre", "DNI", "Motivo", "Descripción", "Cadete Sede"]);

    // Recorrer las compañías y agregar los datos a las filas
    Object.keys(groupedByCompania).forEach((compania) => {
      groupedByCompania[compania].forEach((cadete) => {
        rows.push([
          compania,
          formatFechaHora(cadete.fechaAviso),
          cadete.cadeteApellido,
          cadete.cadeteNombre,
          cadete.cadeteDni,
          cadete.Motivo,
          cadete.descripcion,
          cadete.cadeteSede,
        ]);
      });
    });

    // Crear el libro de trabajo
    const ws = XLSX.utils.aoa_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Avisos");

    const fecha = new Date();
    XLSX.writeFile(wb, 'Avisos_Sede_' + sede + " " + fecha.toLocaleString() + '.xlsx');
  };

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <h4>Avisos sede: {sede} de las últimas 72hs</h4>
      <hr />

      {Object.keys(groupedByCompania).map((compania) => (
        <div key={compania}>
          <h4 style={{ background: "#777" }}>{compania}</h4>
          <ul style={{ width: "100%", textAlign: "left" }}>
            {groupedByCompania[compania].map((cadete, index) => (
              <li key={cadete.cadeteDni} style={{ cursor: "pointer" }} onClick={() => InfoCadete(cadete.cadeteDni)}>
                {index + 1}) Fecha Aviso: {formatFechaHora(cadete.fechaAviso)} -{" "}
                <strong>{cadete.cadeteApellido}, {cadete.cadeteNombre}</strong>{" "}
                ({cadete.cadeteDni}) - Motivo: {cadete.Motivo + " (" + cadete.descripcion + ")"}
              </li>
            ))}
          </ul>
        </div>
      ))}
      <button className="btn btn-success" onClick={exportToExcel}>Descargar Excel Avisos</button>
    </div>
  );
};

export default DevuelveAvisos;
